type Props = {
  text: string;
};

export function EyebrowText({ text }: Props) {
  return (
    <div style="max-width: 860px; margin: 0 auto; padding: 40px 20px 0;">
      <p style="font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px; color: var(--m-blue); margin: 0;">
        {text}
      </p>
    </div>
  );
}
